var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProviderImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2896_68510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.003 8.97949C27.0043 8.97949 21.3105 14.6733 21.3105 21.6719C21.3105 25.0686 22.6501 28.923 24.8938 31.9823C27.4315 35.4426 30.6667 37.3484 34.003 37.3484C37.3394 37.3484 40.5744 35.4428 43.1124 31.9823C45.3561 28.923 46.6956 25.0686 46.6956 21.6719C46.6956 14.6733 41.0016 8.97949 34.003 8.97949ZM34.003 34.6424C31.5863 34.6424 29.0615 33.0896 27.0759 30.3819C25.1889 27.809 24.0166 24.4715 24.0166 21.6719C24.0166 16.1654 28.4965 11.6856 34.003 11.6856C39.5095 11.6856 43.9893 16.1654 43.9893 21.6719C43.9895 27.3892 39.2874 34.6424 34.003 34.6424Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 0C17.4581 0 4 13.4579 4 30C4 46.5419 17.4579 60 34 60C50.5421 60 64 46.5421 64 30C64 13.4579 50.5419 0 34 0ZM34 57.2939C28.57 57.2937 23.5056 55.6993 19.2495 52.9548C19.3974 48.8111 21.2733 44.9262 24.4495 42.229C25.7116 41.1572 27.5547 41.0401 29.0358 41.9376C30.6356 42.9071 32.306 43.3987 34.0005 43.3987C35.6947 43.3987 37.3646 42.9073 38.9637 41.9383C40.4432 41.0417 42.2813 41.1545 43.5375 42.2189C46.7161 44.9123 48.6026 48.8084 48.7503 52.9552C44.4942 55.6995 39.4298 57.2939 34 57.2939ZM51.3011 51.0941C50.7167 46.8576 48.593 42.9558 45.2869 40.1543C43.1419 38.3369 40.0371 38.1237 37.5612 39.6241C35.2206 41.0423 32.7794 41.0421 30.4383 39.6234C27.9595 38.1211 24.8491 38.3396 22.6978 40.1664C19.3945 42.9715 17.2793 46.8621 16.6966 51.0923C10.6009 46.0824 6.70608 38.4877 6.70608 30.0002C6.70608 14.95 18.9502 2.70608 34 2.70608C49.05 2.70608 61.2939 14.95 61.2939 30C61.2939 38.4886 57.3982 46.0842 51.3011 51.0941Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2896_68510",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2896_68510"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2896_68510",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderImage);
export default __webpack_public_path__ + "static/media/provider_image.d5c5a5b63cdb623d68cf22cd648de5df.svg";
export { ForwardRef as ReactComponent };